var _path, _line, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5, _line2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockedPlacementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 140,
    viewBox: "0 0 183 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 35V56",
    stroke: "#6E28FC",
    strokeDasharray: "2 2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 137,
    y1: 31.5,
    x2: 113,
    y2: 31.5,
    stroke: "#6E28FC",
    strokeDasharray: "2 2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 61,
    width: 103,
    height: 47,
    fill: "#DAD8DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 82L57 82",
    stroke: "#6E28FC",
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 56,
    width: 23,
    height: 15,
    fill: "#EFEEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56V31H110.158V45.1667H120V56H18Z",
    fill: "#EFEEEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 31,
    width: 91,
    height: 4,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130 50.7953V44.59H140.929V35H164V57H140.929V50.7953H130Z",
    fill: "#EFEEEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 92,
    width: 39,
    height: 16,
    fill: "#EFEEEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141 31H164V35H141V31Z",
    fill: "#D9D9D9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 75,
    x2: 18.5,
    y2: 88,
    stroke: "#6E28FC",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedPlacementIcon);
export default __webpack_public_path__ + "static/media/locked-placement-icon.0a6bfb3a660ac11272671c391c4213d2.svg";
export { ForwardRef as ReactComponent };